/**
 * Mobile header: hide on scroll down, show on scroll up.
 * Desktop (≥992px) is unchanged. Stays visible while the nav menu is open
 * and near the top of the page.
 */
(function () {
  var header = document.querySelector('body > .navbar-container');
  if (!header) return;

  // Course detail keeps site + section navs pinned together; autohide fights that layout.
  var autohideDisabled = !!document.getElementById('courseSubnav');

  var mq = window.matchMedia('(max-width: 991.98px)');
  var lastY = window.scrollY || 0;
  var ticking = false;
  var hidden = false;
  var deltaThreshold = 8;
  var topReveal = 48;

  function menuIsOpen() {
    var nav = header.querySelector('.navbar');
    return !!(nav && nav.classList.contains('navbar-toggled-show'));
  }

  function syncSiteHeaderHeight() {
    var navHeight = header.offsetHeight;
    if (!autohideDisabled && header.classList.contains('navbar-container--scroll-hidden')) {
      navHeight = 0;
    }
    document.documentElement.style.setProperty('--site-header-height', navHeight + 'px');
  }

  function setHidden(next) {
    if (autohideDisabled || !mq.matches) next = false;
    if (hidden === next) return;
    hidden = next;
    header.classList.toggle('navbar-container--scroll-hidden', next);
    document.body.classList.toggle('navbar-scroll-hidden', next);
    syncSiteHeaderHeight();
    document.dispatchEvent(new CustomEvent('navbar-autohide-change', {
      detail: { hidden: next },
    }));
  }

  function update() {
    ticking = false;

    if (autohideDisabled || !mq.matches || menuIsOpen()) {
      setHidden(false);
      lastY = window.scrollY || 0;
      return;
    }

    var y = window.scrollY || 0;
    var dy = y - lastY;

    if (y <= topReveal) {
      setHidden(false);
    } else if (dy > deltaThreshold) {
      setHidden(true);
    } else if (dy < -deltaThreshold) {
      setHidden(false);
    }

    lastY = y;
  }

  function onScroll() {
    if (autohideDisabled) return;
    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(update);
    }
  }

  function onViewportChange() {
    lastY = window.scrollY || 0;
    update();
  }

  function onResize() {
    syncSiteHeaderHeight();
    if (!autohideDisabled) onViewportChange();
  }

  syncSiteHeaderHeight();
  if (!autohideDisabled) {
    window.addEventListener('scroll', onScroll, { passive: true });
  }
  window.addEventListener('resize', syncSiteHeaderHeight);
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(syncSiteHeaderHeight).catch(function() {});
  }
  if (!autohideDisabled) {
    if (mq.addEventListener) {
      mq.addEventListener('change', onResize);
    } else if (mq.addListener) {
      mq.addListener(onResize);
    }
  }

  function onMenuCollapseChange() {
    setHidden(false);
    requestAnimationFrame(syncSiteHeaderHeight);
  }

  var menu = document.getElementById('navigation-menu');
  if (menu) {
    menu.addEventListener('show.bs.collapse', onMenuCollapseChange);
    menu.addEventListener('shown.bs.collapse', syncSiteHeaderHeight);
    menu.addEventListener('hide.bs.collapse', syncSiteHeaderHeight);
    menu.addEventListener('hidden.bs.collapse', syncSiteHeaderHeight);
  }
})();
